import PropTypes from 'prop-types';
import React from 'react';

import { withFormsy } from 'formsy-react';
import { Switch } from 'twyne-new.ui';

class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: true,
    };
  }

  render() {
    // const { setValue, getValue, getErrorMessage, isValid, isPristine, type } = this.props
    // const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid' : ''
    const value = this.props.getValue();

    return (
      <Switch
        onChange={this.props.handleOnChange}
        id={this.props.name}
        value={value ? value : false}
      />
    );
  }
}

Checkbox.propTypes = {
  handleOnChange: PropTypes.func,
}

export default withFormsy(Checkbox);
